import {gql} from "@apollo/client";

export const UPDATE_SUBSCRIPTION_FEATURE = gql`
    mutation UpdateSubscriptionFeature (
        $id: String!
        $key: String
        $name: String
    ) {
        updateSubscriptionFeature(
            subscriptionFeatureId: $id,
            key: $key,
            name: $name
        ) {
            success
            message
        }
    }
`;
